import {proxy} from "valtio";

import {IValtioModel} from "@/shared/models/base-model.interface";
import {Field, type FieldInstance} from "@/shared/models/form/fields";

export interface VideoModalState {
    isOpen: boolean;
    title: string;
    url: string;
}

class VideoModalModelClass implements IValtioModel {
    state: VideoModalState = {
        isOpen: false,
        title: "",
        url: "",
    };

    private initialized = false;

    // Form fields
    fields: {
        comment: FieldInstance;
        name: FieldInstance;
        email: FieldInstance;
    } = {
        comment: Field({initialValue: ""}),
        name: Field({initialValue: ""}),
        email: Field({initialValue: ""}),
    };

    open(payload: {title: string; url: string}): void {
        this.state.title = payload.title;
        this.state.url = payload.url;
        this.state.isOpen = true;
    }

    close(): void {
        this.state.isOpen = false;
    }

    // Optional lifecycle hooks
    init(): void {
        this.initialized = true;
    }
    dispose(): void {
        this.initialized = false;
        this.close();
    }
}

export type VideoModalModelInstance = VideoModalModelClass;
export function VideoModalModel(): VideoModalModelInstance {
    return proxy(new VideoModalModelClass());
}
